export const OnOffEnum = {
  ON: 'on',
  OFF: 'off',
  properties: {
    on: {
      title: 'On',
      state: 'ON'
    },
    off: {
      title: 'Off',
      state: 'OFF'
    }
  }
}

export const EnableDisableEnum = {
  ENABLE: 'enable',
  DISABLE: 'disable',
  properties: {
    enable: {
      title: 'ACTIVE',
      state: true
    },
    disable: {
      title: 'DISABLED',
      state: false
    }
  }
}



// WEBPACK FOOTER //
// ./src/constants/on-off.constants.js